import { createDate, importAll, transformImages } from "utils";

import GalleryComponent from "components/Media/Gallery";
import QuibblerMain from "../../_hp-quibbler-main";
import QuibblerMakingOf from "../../_hp-quibbler-making-of";
import ReplicaBigTitle from "components/Replicas/ReplicaBigTitle";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaQuote from "components/Replicas/ReplicaQuote";
import ReplicaSpacer from "components/Replicas/ReplicaSpacer";
import { ReplicaVersionType } from "types";
import background from "./background.jpg";
import thumbnail from "./thumbnail.png";

let gallery = [];
let galleryArticles = [];

try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/)
  );
  galleryArticles = importAll(
    (require as any).context("./gallery-articles", false, /\.(png|jpe?g|svg)$/)
  );
} catch (e) {
  console.log(e);
}

/* VERSION DATA */
export const VERSION_DATA: ReplicaVersionType = {
  isWIP: false,
  page: undefined,
  dateCreated: createDate({ day: 1, month: 5, year: 2025 }),
  datePublished: createDate({ day: 1, month: 7, year: 2025 }),
  version: "1",
  isSeries: false,
  thumbnail,
  background,
};

/* VERSION PAGE */
const Page = () => {
  return (
    <ReplicaContent>
      <QuibblerMain
        gallery={transformImages(gallery)}
        galleryImageOptions={[
          { index: 0, aspectRatio: 1.5 },
          { index: 5, aspectRatio: 1.5 },
          { index: 7, aspectRatio: 1.5 },
          { index: 10, aspectRatio: 1.5 },
        ]}
        video={"https://youtu.be/aB8muJHmgJY"}
      />

      <ReplicaBigTitle title="Harry in Hiding!" />

      <ReplicaQuote source="Harry Potter and the Deathly Hallows">
        “The Prophet?” scoffed Ted. “You deserve to be lied to if you’re still
        reading that much, Dirk. You want the facts, try the Quibbler.” There
        was a sudden explosion of choking and retching, plus a good deal of
        thumping, by the sound of it. Dirk had swallowed a fish bone. At last he
        sputtered, “The Quibbler? That lunatic rag of Xeno Lovegood’s?” “It’s
        not so lunatic these days,” said Ted. “You want to give it a look, Xeno
        is printing all the stuff the Prophet’s ignoring, not a single mention
        of Crumple-Horned Snorkacks in the last issue. How long they’ll let him
        get with it, mind, I don’t know.
      </ReplicaQuote>
      <ReplicaSpacer />

      <ReplicaParagraph>
        This issue supposedly came out sometime during the events at the
        beginning of Deathly Hallows, after Harry, Ron, and Hermione had set out
        on their journey to find and destroy the Horcruxes. Since there’s no
        source material for this issue — neither in the books nor in the films
        (aside from the cover design) — I had complete creative freedom over the
        entire magazine. Of course, all the "news" and articles still had to
        align with the timeline, based on the in-universe date of publication.
        That meant not only selecting topics that made sense plot-wise, but also
        adjusting the tone of the issue to reflect the darker, more urgent
        atmosphere of the time — moving away from the usual eccentric features
        like Crumple-Horned Snorkacks and focusing more on current events, as
        hinted at in the excerpt above. That said, even though the events
        reported did happen, The Quibbler still couldn’t resist offering its own
        wild and whimsical explanations.
      </ReplicaParagraph>

      <ReplicaSpacer />
      <GalleryComponent
        images={transformImages(galleryArticles)}
        imagesPerRow={3}
        imageOptions={[{ index: 0, aspectRatio: 2 }]}
        imageMaxHeight="250px"
      />
      <ReplicaSpacer />

      <QuibblerMakingOf />
    </ReplicaContent>
  );
};

export default {
  ...VERSION_DATA,
  page: <Page />,
} as ReplicaVersionType;
